import Api from '@/services/Api'

export default {
    // CORSO
    caricaCorso(id) {
        return Api().get('/corsi/' + id);
    },
    // creaCorso(dati) {
    //     return Api().post('/corsi', dati);
    // },
    // deleteCorso(id) {
    //     return Api().delete('/corsi/' + id);
    // },
    getCorsi() {
        return Api().get('/corsi');
    },
    
    updateCorso(id, dati) {
        return Api().put('/corsi/' + id, dati);
        // PUT https://sviluppoallergeni.confcom.it/corsi/:id
    },

    // CORSISTI
    // getCorsisti(idCorso) {
    //     return Api().get('/' + idCorso);
    // },
    // caricaCorsista(idCorso, idCorsista) {
    //     return Api().get('');
    // },
    // creaCorsista(idCorso, idCorsista) {
    //     return Api().post('', dati);
    // },
    // deleteCorsista(idCorso, idCorsista) {
    //     return Api().delete('');
    // },
    // updateCorsista(idCorso, idCorsista, dati) {
    //     return Api().put('', dati);
    // },
    
    changePage(page, n_righe) {
        return Api().get('/corsi?page=' + page + '&limit=' + n_righe);
      },
}